// third-party
import {
    Assignment,
    Groups2Outlined,
    Inventory2Outlined,
    PaymentsOutlined,
    Person2Outlined,
    PointOfSaleOutlined,
    ReceiptOutlined,
    TuneOutlined,
    Work,
} from '@mui/icons-material';

import { Link } from '@redwoodjs/router';

// constants and enums
import { ROUTES } from 'src/constants';
import { NavItemType, Role, RoleName } from 'src/types';

// ==============================|| MENU ITEMS ||============================== //
// menu items must be associated to a role permission in the schema, otherwise they will not show
export const pages = {
    id: 'pages',
    title: (
        <Link to="/home" style={{ color: '#fff', textDecoration: 'none' }}>
            Dashboard
        </Link>
    ),
    type: 'group',
    children: [
        {
            id: 'merchant',
            title: 'Merchants',
            type: 'collapse',
            icon: PointOfSaleOutlined,
            children: [
                {
                    id: 'add-merchant',
                    title: 'Add Merchant',
                    type: 'item',
                    url: ROUTES.merchant.addMerchant,
                    target: true,
                    permissions: ['addMerchant'],
                },
                {
                    id: 'list-merchant',
                    title: 'View Merchants',
                    type: 'item',
                    url: ROUTES.merchant.listMerchant,
                    target: true,
                    permissions: ['editMerchant', 'viewMerchant', 'changeMerchantStatus'],
                },
                {
                    id: 'cancel-merchant',
                    title: 'Cancel Merchant',
                    type: 'item',
                    url: ROUTES.merchant.cancelMerchant,
                    target: true,
                    permissions: ['cancelServices'],
                },
                {
                    id: 'view-merchant-applications',
                    title: 'In Progress Applications',
                    type: 'item',
                    url: ROUTES.merchant.viewMerchantApplications,
                    target: true,
                    permissions: ['editMerchant', 'viewMerchant', 'changeMerchantStatus'],
                },
                {
                    id: 'trial-merchant-applications',
                    title: 'Trial Merchants',
                    type: 'item',
                    url: ROUTES.merchant.listTrialMerchants,
                    target: true,
                    permissions: ['editMerchant', 'viewMerchant', 'changeMerchantStatus'],
                },
            ],
            roles: [RoleName.NPI, RoleName.PARTNER, RoleName.PARTNER_OF_PARTNER],
        },
        {
            id: 'partner',
            title: 'Partners',
            type: 'collapse',
            icon: Groups2Outlined,
            children: [
                {
                    id: 'add-partner',
                    title: 'Add Partner',
                    type: 'item',
                    url: '/partner/add',
                    target: true,
                    permissions: ['addPartner'],
                },
                {
                    id: 'list-partner',
                    title: 'View Partners',
                    type: 'item',
                    url: '/partners',
                    target: true,
                    permissions: ['viewPartner', 'editPartner', 'changePartnerStatus'],
                },
            ],
            roles: [RoleName.NPI, RoleName.PARTNER],
        },
        {
            id: 'customer-success',
            title: 'Customer Success',
            type: 'collapse',
            icon: Work,
            children: [
                {
                    id: 'check-in-calls',
                    title: 'Check-in Calls',
                    type: 'item',
                    url: ROUTES.customerSuccess.checkInCalls,
                    target: true,
                    permissions: ['customerSuccess'],
                },
            ],
            roles: [RoleName.NPI],
        },
        {
            id: 'product-pricing',
            title: 'Product and Pricing',
            type: 'collapse',
            icon: Inventory2Outlined,
            children: [
                {
                    id: 'product-catalogue',
                    title: 'Product Catalogue',
                    type: 'item',
                    url: ROUTES.productAndPricing.productsCatalogue.products,
                    target: true,
                    permissions: ['pricingAndProductManagement', 'stockManagement'],
                },
                {
                    id: 'terminal-pricing',
                    title: 'Terminal Pricing',
                    type: 'item',
                    url: ROUTES.productAndPricing.terminalPricing.pricings,
                    target: true,
                    permissions: ['pricingAndProductManagement', 'stockManagement'],
                },
                {
                    id: 'online-pricing',
                    title: 'Online Pricing',
                    type: 'item',
                    url: ROUTES.productAndPricing.onlinePricing.pricing,
                    target: true,
                    permissions: ['pricingAndProductManagement', 'stockManagement'],
                },
                {
                    id: 'transaction-pricing',
                    title: 'Transaction Pricing',
                    type: 'item',
                    url: ROUTES.productAndPricing.transactionPricing.pricing,
                    target: true,
                    permissions: ['pricingAndProductManagement', 'stockManagement'],
                },
            ],
            roles: [RoleName.NPI],
        },
        {
            id: 'product-pricing',
            title: 'Product and Pricing',
            type: 'collapse',
            icon: Inventory2Outlined,
            children: [
                {
                    id: 'terminal-pricing',
                    title: 'Terminal Pricing',
                    type: 'item',
                    url: ROUTES.productAndPricing.terminalPricing.pricings,
                    target: true,
                    permissions: [
                        'viewTerminalPricings',
                        'addTerminalPricing',
                        'editTerminalPricing',
                    ],
                },
                {
                    id: 'online-pricing',
                    title: 'Online Pricing',
                    type: 'item',
                    url: ROUTES.productAndPricing.onlinePricing.pricing,
                    target: true,
                    permissions: ['viewOnlinePricing', 'addOnlinePricing', 'editOnlinePricing'],
                },
                {
                    id: 'transaction-pricing',
                    title: 'Transaction Pricing',
                    type: 'item',
                    url: ROUTES.productAndPricing.transactionPricing.pricing,
                    target: true,
                    permissions: [
                        'transactionPricing',
                        'viewTransactionPricing',
                        'addTransactionPricing',
                    ],
                },
            ],
            roles: [RoleName.PARTNER, RoleName.PARTNER_OF_PARTNER],
        },
        {
            id: 'finance',
            title: 'Finance',
            type: 'collapse',
            icon: PaymentsOutlined,
            children: [
                {
                    id: 'invoices',
                    title: 'Sales Invoices',
                    type: 'item',
                    url: ROUTES.finance.salesInvoices,
                    permissions: ['viewFinance', 'addInvoice'],
                },
                {
                    id: 'credits',
                    title: 'Credits',
                    type: 'item',
                    url: ROUTES.finance.credits,
                    permissions: ['viewFinance', 'addCredit'],
                },
                {
                    id: 'accountStatements',
                    title: 'Account Statements',
                    type: 'item',
                    url: ROUTES.finance.accountStatements,
                    permissions: ['viewFinance'],
                },
                {
                    id: 'sepaDirectDebits',
                    title: 'SEPA Direct Debits',
                    type: 'item',
                    url: ROUTES.finance.directDebits,
                    permissions: ['viewFinance'],
                },
                {
                    id: 'self-billing-invoices',
                    title: 'Self-Billing Invoices',
                    type: 'item',
                    url: ROUTES.finance.selfBillingInvoices,
                    permissions: ['viewSelfBillingInvoices'],
                },
            ],
            roles: [RoleName.NPI, RoleName.PARTNER],
        },
        {
            id: 'commissions',
            title: 'Commissions',
            type: 'collapse',
            icon: ReceiptOutlined,
            children: [
                {
                    id: 'online',
                    title: 'Online',
                    type: 'item',
                    url: ROUTES.finance.commissions.online,
                    permissions: ['viewCommissions'],
                },
                {
                    id: 'terminal',
                    title: 'Terminal',
                    type: 'item',
                    url: ROUTES.finance.commissions.terminal,
                    permissions: ['viewCommissions'],
                },
                {
                    id: 'transaction',
                    title: 'Transaction',
                    type: 'item',
                    url: ROUTES.finance.commissions.transaction,
                    permissions: ['viewCommissions'],
                },
            ],
            roles: [RoleName.NPI, RoleName.PARTNER],
        },
        {
            id: 'partner-resources',
            title: 'Partner Resources',
            type: 'collapse',
            icon: Assignment,
            children: [
                {
                    id: 'view-partner-resources',
                    title: 'View Resources',
                    type: 'item',
                    url: ROUTES.partnerResources.viewPartnerResources,
                    target: true,
                },
                {
                    id: 'manage-partner-resources',
                    title: 'Manage Partner Resources',
                    type: 'item',
                    url: ROUTES.partnerResources.managePartnerResources,
                    target: true,
                    permissions: ['managePartnerResources'],
                },
            ],
            roles: [RoleName.NPI, RoleName.PARTNER, RoleName.PARTNER_OF_PARTNER],
        },
        {
            id: 'user-management',
            title: 'User Management',
            type: 'collapse',
            icon: Person2Outlined,
            children: [
                {
                    id: 'users',
                    title: ' Users',
                    type: 'item',
                    url: ROUTES.userManagement.manageUsers,
                    permissions: ['configurationUserManagement'],
                },
                {
                    id: 'roles',
                    title: 'User Roles',
                    type: 'item',
                    url: ROUTES.userManagement.manageRoles,
                    permissions: ['configurationUserManagement'],
                },
            ],
            roles: [RoleName.NPI],
        },
        {
            id: 'configuration',
            title: 'Configuration',
            type: 'collapse',
            icon: TuneOutlined,
            children: [
                {
                    id: 'mcc',
                    title: 'MCC',
                    type: 'item',
                    url: ROUTES.mcc.listMcc,
                    permissions: ['configurationOther'],
                },
                {
                    id: 'cancellation-reasons',
                    title: 'Cancellation Reasons',
                    type: 'item',
                    url: ROUTES.configuration.cancellationReasons,
                    permissions: ['configurationFinance'],
                },
                {
                    id: 'suspended-reasons',
                    title: 'Suspended Reasons',
                    type: 'item',
                    url: ROUTES.configuration.suspendedReasons,
                    permissions: ['configurationFinance'],
                },
                {
                    id: 'audit-logs',
                    title: 'Audit Log',
                    type: 'item',
                    url: ROUTES.configuration.auditLogs.viewAuditLog,
                    permissions: ['configurationAuditLog'],
                },
                {
                    id: 'remove-stock-reasons',
                    title: 'Remove Stock Reasons',
                    type: 'item',
                    url: ROUTES.configuration.removeStockReasons,
                    permissions: ['configurationFinance'],
                },
                {
                    id: 'sage-system-user',
                    title: 'Sage System User',
                    type: 'modal',
                    permissions: ['configurationSage'],
                },
                {
                    id: 'configuration-partner-resources',
                    title: 'Configuration Partner Resources',
                    type: 'item',
                    url: ROUTES.configuration.configurePartnerResources,
                    permissions: ['configurationPartnerResources'],
                },
                {
                    id: 'check-in-call-setup',
                    title: 'Check-in Call Setup',
                    type: 'item',
                    url: ROUTES.configuration.checkInCallSetup,
                    permissions: ['configurationOther'],
                },
            ],
            roles: [RoleName.NPI],
        },
    ],
};

// this method now factors in role permissions on each child item in the menu
// also if a parent menu item no longer has children to show, it doesn't show regardless of the hierarchy level
const filterMenuItems = (role: Role) => {
    if (!role) {
        return null;
    }
    const roleItems = pages.children
        .map((parentItem) => {
            if (parentItem.roles.includes(role.hierarchyLevel)) {
                const filteredChildren = parentItem.children.filter((childItem) => {
                    if (childItem.permissions) {
                        return childItem.permissions.some((itemPermission) => {
                            return role.permissions.some((permission: { [x: string]: boolean }) => {
                                return permission[itemPermission] === true;
                            });
                        });
                    }
                    return true;
                });

                if (filteredChildren.length === 0) {
                    return null;
                }
                return { ...parentItem, children: filteredChildren };
            }
            return null;
        })
        .filter(Boolean);

    return { ...pages, children: roleItems };
};

export const getMenuItems = (role: Role) => {
    const pageArr = filterMenuItems(role);
    const menuItems: { items: NavItemType[] } = {
        items: [pageArr],
    };

    return menuItems;
};

export const getRouteHeader = (path: string): string => {
    const match = pages.children.find((child) => {
        return child.children.find(({ url }) => {
            return url === path;
        });
    });

    if (!match || !match?.children?.length) {
        return match?.title || '';
    }

    const child = match.children.find(({ url }) => {
        return url === path;
    });

    return child.title;
};
